import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putEditInviteSupplier = createApi(`PUTEditInviteUserSlice`,"PUT");

const PUTEditInviteUserSlice = createSlice({
  name: 'PUTEditInviteUserSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putEditInviteSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putEditInviteSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putEditInviteSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PUTEditInviteUserSlice.reducer;